import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import {
  Stack,
  FormControl,
  FormLabel,
  Input,
  FormHelperText,
  Button,
  Alert,
  AlertIcon,
  Text,
  useToast,
  Image,
} from "@chakra-ui/react";
import { getHomeAbout, updateHomeAbout } from "src/store/settings/home/homeAboutSlice";
import React, { useEffect } from "react";
import { baseUrl } from "src/utilities/axios";

const About = () => {
  const { t } = useTranslation();
  const toast = useToast({ position: "top", status: "success", duration: 3000 });
  const dispatch = useDispatch();
  const homeAbout = useSelector(state => state.homeAbout);

  console.log(homeAbout);

  const {
    register,
    formState: { errors },
    handleSubmit,
    getValues,
    reset,
    watch,
    setValue
  } = useForm();

  watch(["image"]);

  useEffect(() => {
    dispatch(getHomeAbout())
      .unwrap()
      .then(res => {
        reset(res.data)
      })
      .catch(e => console.log(e))
  }, [dispatch, reset]);

  return (
    <form onSubmit={handleSubmit((values, even) => {
      dispatch(updateHomeAbout(even.target))
        .unwrap()
        .then(_ => {
          toast({ description: "settings updated" });
        })
        .catch(e => {
          window.scrollTo(0, 0);
        })
    })}>
      <Stack spacing={6}>
        {homeAbout?.error && (
          <Alert status="error" variant="left-accent">
            <AlertIcon />
            <Text>{homeAbout?.error || "-"}</Text>
          </Alert>
        )}

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.home.about.title_ar")}
          </FormLabel>
          <Input
            type="text" placeholder={t("pages.settings.home.about.title_ar")}
            height="48px" borderRadius={4}
            {...register("title_ar", {
              required: t("validation.required")
            })}
          />
          {errors.title_ar && (
            <FormHelperText color="red.600">{errors.title_ar.message}</FormHelperText>
          )}
        </FormControl>

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.home.about.title_en")}
          </FormLabel>
          <Input
            type="text" placeholder={t("pages.settings.home.about.title_en")}
            height="48px" borderRadius={4}
            {...register("title_en", {
              required: t("validation.required")
            })}
          />
          {errors.title_en && (
            <FormHelperText color="red.600">{errors.title_en.message}</FormHelperText>
          )}
        </FormControl>

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.home.about.subtitle_ar")}
          </FormLabel>
          <Input
            type="text" placeholder={t("pages.settings.home.about.subtitle_ar")}
            height="48px" borderRadius={4}
            {...register("subtitle_ar", {
              required: t("validation.required")
            })}
          />
          {errors.subtitle_ar && (
            <FormHelperText color="red.600">{errors.subtitle_ar.message}</FormHelperText>
          )}
        </FormControl>

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.home.about.subtitle_en")}
          </FormLabel>
          <Input
            type="text" placeholder={t("pages.settings.home.about.subtitle_en")}
            height="48px" borderRadius={4}
            {...register("subtitle_en", {
              required: t("validation.required")
            })}
          />
          {errors.subtitle_en && (
            <FormHelperText color="red.600">{errors.subtitle_en.message}</FormHelperText>
          )}
        </FormControl>

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.home.about.description_ar")}
          </FormLabel>
          <Input
            type="text" placeholder={t("pages.settings.home.about.description_ar")}
            height="48px" borderRadius={4}
            {...register("description_ar", {
              required: t("validation.required")
            })}
          />
          {errors.description_ar && (
            <FormHelperText color="red.600">{errors.description_ar.message}</FormHelperText>
          )}
        </FormControl>

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.home.about.description_en")}
          </FormLabel>
          <Input
            type="text" placeholder={t("pages.settings.home.about.description_en")}
            height="48px" borderRadius={4}
            {...register("description_en", {
              required: t("validation.required")
            })}
          />
          {errors.description_en && (
            <FormHelperText color="red.600">{errors.description_en.message}</FormHelperText>
          )}
        </FormControl>

        <FormControl>
          <FormLabel textTransform="capitalize">
            {t("pages.settings.home.about.image")}
          </FormLabel>
          <Input
            type="file" placeholder={t("pages.settings.home.about.image")}
            height="48px" borderRadius={4} pt={2}
            {...register("image")}
          />
          {typeof (getValues("image")) === "string" && getValues("image") && (
            <>
              <input type="hidden" name="edited_image" value={getValues("image")} />
              <Image mt={2} src={`${baseUrl}/about/${getValues("image")}`} height="150px" objectFit="contain" />
              <Button mt={2} bg="red.600" color="white" type="button" onClick={() => setValue("image", null)}>
                {t("general.delete")}
              </Button>
            </>
          )}
        </FormControl>

        <Button
          type="submit"
          bg="green.600"
          isLoading={homeAbout.isLoading}
          color="white"
          textTransform="capitalize"
          _hover={{ bg: "green.600" }}
        >
          {t("general.save")}
        </Button>
      </Stack>
    </form>
  )
}

export default About